import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgSbusiness24 = function SvgSbusiness24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.61 8H1.389C.622 8 0 8.591 0 9.32v21.36C0 31.41.622 32 1.388 32h37.224c.766 0 1.388-.591 1.388-1.32V9.32C40 8.59 39.377 8 38.61 8Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.172 18.036c0-.013.01-.023.022-.023h.326c.482 0 .636-.042.804-.224.16-.174.166-.514.166-.764v-.995c0-.729.073-1.237.17-1.623.096-.385.466-1.28 1.156-1.925.69-.644 1.324-.916 1.82-1.065.515-.155 1.072-.189 1.569-.189h.32c.013 0 .023.01.023.023v1.694c0 .013-.01.022-.023.022h-.298c-.554 0-1.059.078-1.349.197a2.81 2.81 0 0 0-1.16.912c-.342.464-.488.9-.488 1.78 0 .587-.001-.062-.001.868 0 .386.02.853-.101 1.287a2.055 2.055 0 0 1-.63 1.027c-.413.39-.971.702-2.064.702h-.242a.022.022 0 0 1-.022-.022l.002-1.682Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.172 18.036c0-.013.01-.023.022-.023h.326c.482 0 .636-.042.804-.224.16-.174.166-.514.166-.764v-.995c0-.729.073-1.237.17-1.623.096-.385.466-1.28 1.156-1.925.69-.644 1.324-.916 1.82-1.065.515-.155 1.072-.189 1.569-.189h.32c.013 0 .023.01.023.023v1.694c0 .013-.01.022-.023.022h-.298c-.554 0-1.059.078-1.349.197a2.81 2.81 0 0 0-1.16.912c-.342.464-.488.9-.488 1.78 0 .587-.001-.062-.001.868 0 .386.02.853-.101 1.287a2.055 2.055 0 0 1-.63 1.027c-.413.39-.971.702-2.064.702h-.242a.022.022 0 0 1-.022-.022l.002-1.682Z",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.55 14.907c0 .013-.011.022-.023.022H23.2c-.482 0-.636.042-.804.225-.16.174-.167.513-.167.764v.994c0 .73-.073 1.238-.17 1.623-.097.386-.466 1.28-1.156 1.926-.69.643-1.324.915-1.82 1.064-.515.156-1.072.19-1.569.19h-.32a.022.022 0 0 1-.023-.023v-1.694c0-.013.01-.023.023-.023h.298c.554 0 1.059-.077 1.349-.196.47-.192.884-.539 1.16-.913.342-.463.488-.9.488-1.78 0-.586.001.063.001-.867 0-.387-.02-.853.101-1.287.136-.485.345-.759.63-1.027.413-.39.971-.703 2.064-.703h.241c.013 0 .023.01.023.023v1.682Z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.55 14.907c0 .013-.011.022-.023.022H23.2c-.482 0-.636.042-.804.225-.16.174-.167.513-.167.764v.994c0 .73-.073 1.238-.17 1.623-.097.386-.466 1.28-1.156 1.926-.69.643-1.324.915-1.82 1.064-.515.156-1.072.19-1.569.19h-.32a.022.022 0 0 1-.023-.023v-1.694c0-.013.01-.023.023-.023h.298c.554 0 1.059-.077 1.349-.196.47-.192.884-.539 1.16-.913.342-.463.488-.9.488-1.78 0-.586.001.063.001-.867 0-.387-.02-.853.101-1.287.136-.485.345-.759.63-1.027.413-.39.971-.703 2.064-.703h.241c.013 0 .023.01.023.023v1.682Z",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.617h1.622c1.198 0 1.595.606 1.595 1.348 0 .443-.254.885-.699 1.076.589.156.87.701.87 1.245 0 .797-.438 1.437-1.718 1.437H8v-5.106Zm1.657.45h-1.17v1.783h1.225c.773 0 .965-.45.965-.886 0-.448-.151-.898-1.02-.898v0Zm-1.17 4.207h1.21c.966 0 1.15-.498 1.15-.988 0-.687-.294-.987-1.135-.987H8.486v1.975Z",
    fill: "url(#c)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.508 27.811c0 .443.26.579.684.579.445 0 .67-.075.924-.218V25.32h.479v3.404h-.267l-.102-.287a1.71 1.71 0 0 1-1.034.354c-.814 0-1.163-.367-1.163-1.02V25.32h.479v2.491Z",
    fill: "url(#d)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.539 26.77c.972.088 1.204.415 1.204.973 0 .524-.335 1.048-1.375 1.048-.328 0-.8-.082-1.02-.17v-.408a3.04 3.04 0 0 0 1.027.156c.711 0 .903-.3.903-.62 0-.313-.096-.53-.773-.585-.992-.089-1.198-.435-1.198-.905 0-.484.314-1.007 1.28-1.007.322 0 .685.04.986.17v.408a2.85 2.85 0 0 0-.993-.157c-.677 0-.821.252-.821.586 0 .3.123.456.78.51Z",
    fill: "url(#e)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.572 28.042V25.32h.465v2.778c0 .238.075.306.287.306v.388c-.492 0-.752-.204-.752-.749Z",
    fill: "url(#f)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.234 26.252c0-.443-.26-.58-.684-.58-.445 0-.671.075-.924.219v2.832h-.479v-3.404h.267l.102.286c.322-.238.67-.354 1.034-.354.814 0 1.163.367 1.163 1.021v2.45h-.479v-2.47Z",
    fill: "url(#g)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.88 25.25c1.163 0 1.3.79 1.3 1.77v.219h-2.259c.028.592.185 1.13.959 1.13.492 0 .794-.049 1.13-.191v.408c-.384.17-.795.204-1.13.204-1.157 0-1.438-.79-1.438-1.77s.282-1.77 1.438-1.77v0Zm-.958 1.601h1.78c0-.606-.035-1.178-.822-1.178-.793 0-.938.566-.958 1.178Z",
    fill: "url(#h)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.014 26.77c.972.088 1.204.415 1.204.973 0 .524-.335 1.048-1.376 1.048-.328 0-.8-.082-1.02-.17v-.408c.212.074.541.156 1.027.156.712 0 .903-.3.903-.62 0-.313-.096-.53-.773-.585-.992-.089-1.198-.435-1.198-.905 0-.484.316-1.007 1.28-1.007.322 0 .685.04.986.17v.408a2.85 2.85 0 0 0-.993-.157c-.678 0-.821.252-.821.586.001.3.124.456.78.51v0Z",
    fill: "url(#i)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.033 26.77c.972.088 1.204.415 1.204.973 0 .524-.335 1.048-1.375 1.048-.33 0-.8-.082-1.02-.17v-.408c.212.074.54.156 1.026.156.712 0 .904-.3.904-.62 0-.313-.096-.53-.773-.585-.993-.089-1.198-.435-1.198-.905 0-.484.314-1.007 1.28-1.007.322 0 .684.04.985.17v.408a2.849 2.849 0 0 0-.992-.157c-.678 0-.822.252-.822.586 0 .3.124.456.78.51v0Z",
    fill: "url(#j)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.805 24.118a.37.37 0 0 1 .376.374.37.37 0 0 1-.376.375.37.37 0 0 1-.377-.375.37.37 0 0 1 .377-.374Z",
    fill: "url(#k)",
    stroke: "#AAA8AA",
    strokeWidth: 0.072,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.5,
    width: 39,
    height: 23,
    rx: 1.5,
    stroke: "#C4C4C4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 20.054,
    y1: 22.53,
    x2: 20.542,
    y2: 11.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#868588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696,
    stopColor: "#A09FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.52,
    y1: 23.773,
    x2: 21.09,
    y2: 11.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.028,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#808083"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#979699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#A5A3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 9.694,
    y1: 30.813,
    x2: 9.694,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#696A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#989799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.312,
    y1: 30.813,
    x2: 13.312,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#89898C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#A1A0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 16.526,
    y1: 30.813,
    x2: 16.526,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#818184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#9F9DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 18.948,
    y1: 30.281,
    x2: 18.948,
    y2: 24.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#8A8A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 21.43,
    y1: 30.814,
    x2: 21.43,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#6C6C70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#8E8D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#A2A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 24.812,
    y1: 30.814,
    x2: 24.812,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#6D6E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#8E8E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726,
    stopColor: "#A3A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 28,
    y1: 30.813,
    x2: 28,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#838285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9F9EA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 31.019,
    y1: 30.813,
    x2: 31.019,
    y2: 23.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#818184"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9F9DA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#AAA8AA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 18.805,
    y1: 25.375,
    x2: 18.805,
    y2: 23.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.049,
    stopColor: "#65666A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.135,
    stopColor: "#737377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#8B8A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#9C9B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#A7A5A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAA8AA"
  })))));
};

var Sbusiness24Svg = SvgSbusiness24;

export { Sbusiness24Svg as default };
//# sourceMappingURL=Sbusiness24.svg.js.map
